export function normalizeColumnName(name: string, keepParentheses = false): string {
  if (!name) return ''
  let cleaned = name.replace(/[\r\n]+/g, ' ').toLowerCase()
  if (!keepParentheses) {
    cleaned = cleaned.replace(/\s*\([^)]*\)\s*/g, '')
  }
  return cleaned
    .replace(/[áàâãä]/g, 'a')
    .replace(/[éèêë]/g, 'e')
    .replace(/[íìîï]/g, 'i')
    .replace(/[óòôõöº]/g, 'o')
    .replace(/[úùûü]/g, 'u')
    .replace(/[ç]/g, 'c')
    .replace(/[ñ]/g, 'n')
    .replace(/[ª]/g, 'a')
    .replace(/\s+/g, ' ')
    .trim()
}

export function extractPossibleNames(name: string): string[] {
  const withParentheses = normalizeColumnName(name, true)
  const withoutParentheses = normalizeColumnName(name, false)
  const names = [withParentheses]
  if (withoutParentheses !== withParentheses) {
    names.push(withoutParentheses)
  }

  const finalNames = [...names]
  names.forEach(n => {
    if (n.includes(' = ')) {
      const parts = n.split(' = ')
      finalNames.push(parts[0].trim())
      finalNames.push(parts[1].trim())
    }
    if (n.includes(' - ')) {
      const parts = n.split(' - ')
      finalNames.push(parts[0].trim())
      finalNames.push(parts[1].trim())
    }
  })

  return finalNames
}

export const columnMappingRules: { [key: string]: string } = {
  acabamento: 'finishing',
  fabricacao: 'fabrication',
  'cmc total': 'totalCmc',
  'total cmc': 'totalCmc',
  cmc: 'totalCmc',
  comprimento: 'lengthInMm',
  'custo por kg': 'costPerKg',
  'custo (kg)': 'costPerKg',
  'custo por mm': 'costPerMm',
  'custo (mm)': 'costPerMm',
  'custo (un)': 'price',
  'custo total': 'totalCost',
  codigo: 'code',
  'data de recebimento': 'receivedDate',
  densidade: 'density',
  'dimensao 1': 'dimension1',
  'dimensao 2': 'dimension2',
  formato: 'format',
  fornecedor: 'supplier',
  fornecedores: 'supplier',
  material: 'material',
  ncm: 'ncm',
  'n de corrida': 'heatNumber',
  'no de corrida': 'heatNumber',
  'numero de corrida': 'heatNumber',
  'n da corrida': 'heatNumber',
  'no da corrida': 'heatNumber',
  'numero da corrida': 'heatNumber',
  corrida: 'heatNumber',
  'n de rastreamento': 'trackingNumber',
  'no de rastreamento': 'trackingNumber',
  'numero de rastreamento': 'trackingNumber',
  rastreamento: 'trackingNumber',
  re: 'trackingNumber',
  descricao: 'description',
  caracteristica: 'characteristic',
  familia: 'family',
  'ordem de compra': 'purchaseOrder',
  'pais de origem': 'originCountry',
  'peso total': 'totalWeight',
  peso: 'totalWeight',
  quantidade: 'quantity',
  'quantidade (un)': 'quantity',
  'tratamento termico': 'heatTreatment',
  unidade: 'measurementUnit',
  rua: 'stockStreet',
  'rua do estoque': 'stockStreet',
  prateleira: 'shelf',
  localizacao: 'stockLocation',
  'localizacao no estoque': 'stockLocation',
  'localizacao do estoque': 'stockLocation',
  cor: 'color',
  status: 'status',
  situacao: 'status',
  disponivel: 'isActivated',
  disponibilidade: 'isActivated',
  ativo: 'isActivated',
  inativo: 'isActivated',
  'ativo/inativo': 'isActivated',
  'ativo ou inativo': 'isActivated',
  insumo: 'name',
  aviamento: 'name',
  nome: 'name',
  categoria: 'category',
  tipo: 'type',
  markup: 'markup',
  preco: 'price',
  'preco (un)': 'price',
  'estoque minimo': 'minQuantity',
  'estoque maximo': 'maxQuantity',
  minimo: 'minQuantity',
  maximo: 'maxQuantity',
  'nota fiscal': 'invoice',
  nf: 'invoice',
  certificados: 'certificate',
  certificado: 'certificate',
  'codigo da transportadora': 'carrierCode',
  'cod da transportadora': 'carrierCode',
  'codigo transportadora': 'carrierCode',
  transportadora: 'carrierCode',
  'conjunto de quantidades': 'quantities',
  'conjunto de quantidade': 'quantities',
  quantidades: 'quantities',
  'quantidade kg': 'quantities_kg',
  'quantidade mm': 'quantities_mm',
  'quantidade un': 'quantities_un',
  'quantidade m²': 'quantities_m2',
  'quantidade m2': 'quantities_m2',
  'quantidade m linear': 'quantities_mlinear',
  'quantidade metro linear': 'quantities_mlinear',
  'quantidade %': 'quantities_percent',
  'quantidade porcentagem': 'quantities_percent',
  'quantidade percentual': 'quantities_percent',
  'quantidade litros': 'quantities_liters',
  'quantidade litro': 'quantities_liters',
  'conjunto de preco': 'prices',
  'conjunto de precos': 'prices',
  precos: 'prices',
  'preco kg': 'prices_kg',
  'preco mm': 'prices_mm',
  'preco un': 'prices_un',
  'preco m²': 'prices_m2',
  'preco m2': 'prices_m2',
  'preco m linear': 'prices_mlinear',
  'preco metro linear': 'prices_mlinear',
  'preco %': 'prices_percent',
  'preco porcentagem': 'prices_percent',
  'preco percentual': 'prices_percent',
  'preco litros': 'prices_liters',
  'preco litro': 'prices_liters',
  'custo kg': 'prices_kg',
  'custo mm': 'prices_mm',
  'custo un': 'prices_un',
  'custo m²': 'prices_m2',
  'custo m2': 'prices_m2',
  'custo m linear': 'prices_mlinear',
  'custo litros': 'prices_liters',
}

export function autoMapSpreadsheetHeaders(headers: string[]): { [key: string]: string } {
  console.log('[AUTO-MAP] Iniciando mapeamento automático dos cabeçalhos:', headers);
  const mapping: { [key: string]: string } = {}
  
  headers.forEach((header) => {
    const possibleNames = extractPossibleNames(header)
    console.log(`[AUTO-MAP] Header: "${header}" -> nomes possíveis para busca:`, possibleNames);
    let mappedValue: string | undefined
    let matchedName: string | undefined
    
    for (const name of possibleNames) {
      if (columnMappingRules[name]) {
        mappedValue = columnMappingRules[name]
        matchedName = name
        break
      }
    }
    
    if (mappedValue) {
      mapping[header] = mappedValue
      console.log(`[AUTO-MAP] MATCH ENCONTRADO: "${header}" -> "${mappedValue}" (matched rule name: "${matchedName}")`);
    } else {
      console.log(`[AUTO-MAP] Nenhum match encontrado para: "${header}"`);
    }
  })
  
  console.log('[AUTO-MAP] Mapeamento automático final construído:', mapping);
  return mapping
}
